import React, { Component } from 'react'
import { getApiBase } from './config'

class Image extends Component {
	render() {
		return (
			<img
				src={`${getApiBase()}/photos/480/${this.props.photo.photo_id}`}
				width={this.props.width}
				alt={this.props.alt || ''}
				className={this.props.className}
				style={this.props.style}
				onError={(e)=>{e.target.onerror = null; e.target.style.display='none'}}
				// alt={this.props.photo.name}
			/>
		)
	}
}

export default Image
